import { fetchPlamaApi } from "../clients/PlamaClient.js";

//GET
export const getUserGroups = async (authenticationToken) => {
    return await fetchPlamaApi('group', authenticationToken, [], 'GET')
};

export const getGroupDetails = async (groupId, authenticationToken) => {
    return await fetchPlamaApi('group/' + groupId, authenticationToken, [], 'GET')
};